import moment from "moment";

const TimeFormat = (value: string) => {

    let hr = moment(value, 'hh:mm A').format('HH:mm')
    const a = `11/21/2019 ${hr}:00 GMT+0000`;
    return a
}

export default TimeFormat